var map = {
	"./ahealthyalternative.png": [
		505,
		505
	],
	"./carmshophealth.png": [
		32459,
		2459
	],
	"./essentialoilwizardry.png": [
		78611,
		8611
	],
	"./greenoutletlifellc.png": [
		74241,
		4241
	],
	"./integrativemedicinetoday.png": [
		40582,
		582
	],
	"./kepro.png": [
		94599,
		4599
	],
	"./livingwelltoday.png": [
		50639,
		639
	],
	"./mkdutchdistributionllc.png": [
		31057,
		1057
	],
	"./naturesvibrations-1.png": [
		40508,
		508
	],
	"./naturesvibrations.png": [
		76937,
		6937
	],
	"./nexusnutrients.png": [
		99717,
		9717
	],
	"./patientfocusedtelehealthllc.png": [
		97024,
		7024
	],
	"./sundancebotanicals.png": [
		58706,
		8706
	],
	"./thewellnessenterpriseinc.png": [
		73771,
		3771
	],
	"./twoplustopicalsllc.png": [
		94311,
		4311
	],
	"./vikasessentials.png": [
		61276,
		1276
	],
	"./vitalelements.png": [
		33163,
		3163
	],
	"./woobamboo.png": [
		36891,
		6891
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 85212;
module.exports = webpackAsyncContext;